import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend, Filler,
} from 'chart.js';
import AdminOverviewTab from './AdminOverviewTab';
import AdminActivityTab from './AdminActivityTab';
import AdminUsersTab from './AdminUsersTab';
import AdminSecurityTab from './AdminSecurityTab';
import AdminNotificationsTab from './AdminNotificationsTab';
import AdminNcfRangesTab from './AdminNcfRangesTab';
import AdminSyncTab from './AdminSyncTab';
import AdminApiServicesTab from './AdminApiServicesTab';
import { useAuth } from '../context/AuthContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend, Filler);

const TABS = [
  { key: 'overview', label: 'Resumen financiero', icon: 'bi-graph-up-arrow', Component: AdminOverviewTab },
  { key: 'activity', label: 'Actividad', icon: 'bi-journal-text', Component: AdminActivityTab },
  { key: 'users', label: 'Usuarios', icon: 'bi-people', Component: AdminUsersTab },
  { key: 'security', label: 'Seguridad', icon: 'bi-shield-lock', Component: AdminSecurityTab },
  { key: 'notifications', label: 'Notificaciones', icon: 'bi-bell', Component: AdminNotificationsTab },
  { key: 'ncf', label: 'Rangos e-NCF', icon: 'bi-123', Component: AdminNcfRangesTab },
  { key: 'sync', label: 'Sincronización', icon: 'bi-arrow-left-right', Component: AdminSyncTab },
  // The company's billing with the services the apps run on — owners only (the API refuses anyone else too).
  { key: 'apis', label: 'Servicios API', icon: 'bi-cloud-check', Component: AdminApiServicesTab, ownerOnly: true },
];

const AdminDashboard = () => {
  const { user } = useAuth();
  const tabs = TABS.filter(t => !t.ownerOnly || user?.isOwner);
  const [active, setActive] = useState(() => sessionStorage.getItem('adminTab') || 'overview');
  const { Component } = tabs.find(t => t.key === active) || tabs[0];
  const choose = (key) => { setActive(key); sessionStorage.setItem('adminTab', key); };

  return (
    <div className="container-fluid p-4">
      <h2 className="app-title mb-3" style={{ textAlign: 'left' }}>Panel de administración</h2>
      <Nav variant="tabs" activeKey={active} onSelect={choose} className="mb-3">
        {tabs.map(t => (
          <Nav.Item key={t.key}>
            <Nav.Link eventKey={t.key}><i className={`bi ${t.icon} me-1`} />{t.label}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <Component />
    </div>
  );
};

export default AdminDashboard;
